import React, { useMemo } from 'react'
import { sortBy } from 'lodash'
import Dropdown from 'components/Dropdown'
import { ActionLink } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/ActionLink'
import styles from 'modules/Services/Network/subcomponents/AccountsList/account-list.module.scss'
import { MainActionButton } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/MainActionButton'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { actionsMap } from 'modules/Services/hooks/useGetAccountAction'
import { Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const ActionsColumn = ({
  row: {
    original: { main_action, extra_actions, extra_info, id, login, auto_replenishment },
  },
  networkType,
  i18n,
}) => {
  const breakpoints = useBreakpoint()
  const map = useMemo(() => actionsMap(breakpoints), [breakpoints])

  const orderedActionsList = sortBy(
    extra_actions.filter(
      (action) => !['deposit', 'refresh', 'history', main_action].includes(action),
    ),
    (action) => map[action]?.order,
  )

  const { toDropdown, toRow } = useMemo(() => {
    const orderedActionsLength = orderedActionsList.length

    return orderedActionsLength > 2
      ? {
          toDropdown: orderedActionsList.slice(0, orderedActionsLength - 1),
          toRow: orderedActionsList.slice(orderedActionsLength - 1),
        }
      : {
          toDropdown: [],
          toRow: orderedActionsList,
        }
  }, [orderedActionsList])

  return (
    <Grid
      gap={16}
      justifyContent={'flex-end'}
      alignItems={'center'}
      wrap={'nowrap'}
      direction={'row'}
    >
      {!!toDropdown.length && (
        <Dropdown wrapItems={true}>
          {toDropdown.reverse().map((action, i) => (
            <ActionLink
              /*@todo тут надо быть аккуратным с выравниванием кнопки по левому краю когда будем избавлятьcя от устаревших variant*/
              variant={'link'}
              fullWidth={true}
              key={'action-link-' + i}
              className={styles['accounts-list__action-link']}
              action={action}
              login={login}
              id={id}
              type={networkType}
              i18n={i18n}
              auto_replenishment={auto_replenishment}
              hideLabel={false}
              extra_info={extra_info}
            />
          ))}
        </Dropdown>
      )}

      {toRow.map((action, i) => (
        <ActionLink
          hideLabel={true}
          key={'action-link-' + i}
          className={styles['accounts-list__action-link']}
          action={action}
          login={login}
          id={id}
          type={networkType}
          i18n={i18n}
          auto_replenishment={auto_replenishment}
          extra_info={extra_info}
        />
      ))}

      {!breakpoints.fbs && (
        <MainActionButton
          id={id}
          main_action={main_action}
          i18n={i18n}
          type={networkType}
        />
      )}
    </Grid>
  )
}

export default ActionsColumn

ActionsColumn.propTypes = {
  row: PropTypes.object.isRequired,
  networkType: PropTypes.string.isRequired,
  i18n: PropTypes.string.isRequired,
}
